import { Link } from '@mui/material';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Breadcrumbs } from 'shared/mui/Breadcrumbs';
import { Typography } from 'shared/mui/Typography';

export type PageHeaderBreadcrumbsProps = {
  listName: React.ReactNode;
  currentPage: string;
  resource?: string;
  showCurrentPage?: boolean;
};

export function PageHeaderBreadcrumbs({
  listName,
  resource,
  currentPage,
  showCurrentPage = false,
}: PageHeaderBreadcrumbsProps): JSX.Element {
  const { pathname } = useLocation();
  const { createPathWithQuery } = useCreatePathWithQuery();
  const [listUrl, ...pageUrls] = pathname.split('/').slice(1);

  return (
    <Breadcrumbs sx={{ marginTop: '24px' }}>
      <Link
        component={RouterLink}
        key={listUrl}
        sx={{ textDecoration: 'none', color: 'primary.main' }}
        to={createPathWithQuery({ resource: resource || listUrl, type: 'list' })}
      >
        {listName}
      </Link>
      {(showCurrentPage || pageUrls.length > 0) && (
        <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)' }}>{currentPage}</Typography>
      )}
    </Breadcrumbs>
  );
}
